import script from "./loginView.vue?vue&type=script&setup=true&lang=js"
export * from "./loginView.vue?vue&type=script&setup=true&lang=js"

import "./loginView.vue?vue&type=style&index=0&id=04af2c5f&lang=css"

const __exports__ = script;

export default __exports__